import { Component, Input, OnChanges,} from '@angular/core';
import { IImagesJato } from 'src/app/model/http/images.model';
import { ISearchCars, ITopCars } from 'src/app/model/http/cars.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalSpecsComponent } from './modal-specs/modal-specs.component';
import { SummaryService } from 'src/app/services/summary.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-car-specs',
  templateUrl: `./car-specs.component${environment.templateSuffix}.html`,
  styleUrls: ['./car-specs.component.scss']
})
export class CarSpecsComponent implements OnChanges {
  @Input() specs: any;
  @Input() car!: ITopCars | ISearchCars;
  @Input() images!: IImagesJato;

  arraObject: any = []
  fisrtColumnSpecs: any =[]
  secondColumnSpecs: any = []
  panelOpenState = true;
  templateSuffix: string = '';


  constructor(public dialog: MatDialog, public summaryService: SummaryService) {
    this.templateSuffix = environment.templateSuffix;
  }

  ngOnChanges(changes: any): void {
    this.getSpecs();
  }

  getSpecs() {
      for(const [key, value] of Object.entries(this.specs) as any){
        if(value.especificaciones.length > 0){
          let object = {
            title : key,
            specs : value
          }

          this.arraObject.push(object)
        }
      }
      
      let halfArray = (Math.floor(this.arraObject.length/2));

      this.fisrtColumnSpecs = this.arraObject.slice(0, halfArray);
      this.secondColumnSpecs = this.arraObject.slice(halfArray, this.arraObject.length); 

  }

  generateFicha(){
    this.dialog.open(ModalSpecsComponent, {
      data: {
        title: `${this.car.brand} ${this.car.subBrand}`,
        subtitle: `${this.car.version} ${this.car.year}`,
        imgCar: this.images.imagenes[0],
        fisrtColumnSpecs: this.fisrtColumnSpecs,
        secondColumnSpecs: this.secondColumnSpecs,
        allSpecs: this.arraObject
      },
      panelClass: 'modal-specs-car',
    });
  }


}
